import { Controller } from '@hotwired/stimulus'

let stripeScriptPromise

function loadStripeScript () {
  if (window.Stripe) return Promise.resolve()
  if (!stripeScriptPromise) {
    stripeScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.async = true
      script.onload = () => {
        if (window.Stripe) {
          resolve()
        } else {
          reject(new Error('Stripe.js loaded but Stripe is unavailable'))
        }
      }
      script.onerror = () => reject(new Error('Stripe.js failed to load'))
      document.head.appendChild(script)
    })
  }
  return stripeScriptPromise
}

export default class extends Controller {
  static values = { sessionid: String }

  async connect () {
    // test version
    var pk = "pk_live_51SQ4Hm80RWvwuHPK9pqt1XZTwmMh1nzB0OdUwppuKEyuC53xjMLsx0aeGZgJkEopdiUgaXeKjh6dByVJC5cuZt9g00lJqaUcAc"

    await loadStripeScript().catch((error) => {
      console.error(error)
      stripeScriptPromise = undefined
    })

    const stripeFactory = window.Stripe
    if (!stripeFactory) {
      console.error('Stripe není dostupné, checkout nelze spustit.')
      return
    }

    const stripe = stripeFactory(pk);
    var session_id = this.sessionidValue
    
    stripe.redirectToCheckout({
      sessionId: session_id
    }).then(function (result) {
      console.log(result.error.mesage)
    });

  };
}
